import React, { useEffect } from 'react';
import styles from './index.module.css';

const GooglePhotosConnectButton = ({
  handleGooglePhotosOAuth,
  handleTokenAndLaunchPicker, // ✅ corrected prop name
}) => {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');

    if (code) {
      handleTokenAndLaunchPicker(code); // ✅ this will now work

      // Optional: Clean the URL
      const url = new URL(window.location.href);
      url.searchParams.delete('code');
      url.searchParams.delete('scope');
      window.history.replaceState({}, document.title, url.toString());
    }
  }, []);

  return (
    <button onClick={handleGooglePhotosOAuth} className={styles.connectBtn}>
      Connect Google Photos
    </button>
  );
};

export default GooglePhotosConnectButton;
